import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { List, X, FirstAidKit } from '@phosphor-icons/react';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();

  // Pale yellow background for CMA and Provider, white for others
  const isStaffRole = user?.role === 'cma' || user?.role === 'provider';
  const mainBgClass = isStaffRole ? 'bg-slate-100' : 'bg-white';

  return (
    <div className="dashboard-grid">
      {/* Mobile Header */}
      <div className="mobile-header">
        <div className="flex items-center gap-2">
          <FirstAidKit size={24} weight="duotone" className="text-teal-600" />
          <span className="font-bold text-slate-900">T-MEDCMA</span>
        </div>
        <button
          onClick={() => setSidebarOpen(true)}
          className="p-2 hover:bg-slate-100 rounded-lg"
          data-testid="mobile-menu-btn"
        >
          <List size={24} className="text-slate-600" />
        </button>
      </div>

      {/* Sidebar Overlay (mobile) */}
      {sidebarOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-overlay"
        />
      )}

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Mobile close button */}
        <button
          onClick={() => setSidebarOpen(false)}
          className="lg:hidden absolute top-4 right-4 p-2 hover:bg-slate-100 rounded-lg z-10"
          data-testid="close-sidebar-btn"
        >
          <X size={20} className="text-slate-600" />
        </button>
        <Sidebar onNavigate={() => setSidebarOpen(false)} />
      </div>

      <main className={`main-content ${mainBgClass}`}>
        <Outlet />
      </main>
    </div>
  );
}
